<template>
  <div>
    <div v-for="(error, errorKey) in errors" :key="`${name}-${errorKey}`" class="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: "error"
    },
    errors: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.error {
  color: $danger;
}
</style>